// extracted by extract-css-chunks-webpack-plugin
module.exports = {"fabShippingAddressButton":"registry-page-guest__fabShippingAddressButton__3mSXa"};